'use client';

import { pushStepVariables } from '@/redux/flowSlice';
import { RootState } from '@/redux/store';
import { variables } from '@repo/onb-api';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface TiendanubeHydratorProps {
  tnData: { variables: variables };
}

export default function TiendanubeHydrator({ tnData }: TiendanubeHydratorProps) {
  const dispatch = useDispatch();
  const hasDispatched = useRef(false);
  const steps = useSelector((state: RootState) => state.flowdata.steps);

  useEffect(() => {
    if (tnData && !hasDispatched.current && steps.length > 0) {
      const { variables } = tnData;
      for (const variable of Object.keys(variables)) {
        dispatch(
          pushStepVariables({
            stepName: 'MERCHANT_IDENTIFICATION',
            variable: variable as keyof variables,
            value: variables[variable as keyof variables],
          }),
        );
      }
      hasDispatched.current = true;
    }
  }, [tnData, dispatch, steps]);

  return null;
}
